<section class="itinerary-detail" aria-label="Detalhes dos trechos do itinerário">
  <div class="detail-heading">
    <strong>Detalhamento dos trechos</strong>
  </div>

  <div class="segment-details">
    @for (segment of flight.flightSegments; track segment; let i = $index) {
      <article class="segment-detail">
        <span class="segment-detail__plane" aria-hidden="true">
          <img src="assets/images/airplane_flying.svg" alt="">
        </span>
        <div class="segment-detail__content">
          <div class="segment-detail__title">
            <strong>Trecho {{ i + 1 }}: LA{{ segment.flightNumber }}</strong>
            <span>{{ segment.duration }} de voo</span>
          </div>
          <span>{{ segment.originLocationCode }} → {{ segment.destinationLocationCode }} · {{ segment.originCityName }} → {{ segment.destinationCityName }}</span>
        </div>
        <app-seat-availability [items]="[segment]"></app-seat-availability>
      </article>
    }
  </div>
</section>
